import React from 'react'
import clsx from 'clsx'
import { useTheme } from '@mui/material'
import { useAppSelector } from '@SonarCX/hooks/redux'
import { ExportSquare } from 'iconsax-react'

import { ObjectType } from '../../../types'

import CustomFieldInput from '@SonarCX/components/molecules/CustomFieldInput'
import ButtonMenu from '@SonarCX/components/molecules/ButtonMenu2'
import Spacer from '@SonarCX/components/atoms/Spacer'

import { useFlowTarget } from '../providers/FlowTargetProvider'
import { selectFlows } from '@SonarCX/slices/customFields/flows'
import useStyles from './styles'

type FlowFieldOptionProps = {
  flow: APIFlow
  field: LocalCustomField
  option: APIFlowFieldOption
  onChange: (key: 'when' | 'then', value: any, index: number) => void
  tab: ObjectType
  index?: number
  children?: React.ReactNode
}

const FlowFieldOption: React.FC<FlowFieldOptionProps> = ({
  flow,
  field,
  option,
  onChange,
  tab,
  index = -1,
  children
}) => {
  const theme = useTheme()

  const { flows } = useAppSelector(selectFlows)

  const { setTarget } = useFlowTarget()

  const stageOptions = React.useMemo(() => {
    const ids = flows[tab].map(flow => flow.id).filter(id => id !== flow.id)
    return ids
  }, [flows, tab, flow])

  const classes = useStyles()

  const renderOption = React.useCallback(
    (id: string) => {
      if (id === null) {
        return <div>Select...</div>
      }

      const flow = flows[tab].find(flow => flow.id === id)
      if (!flow) {
        return <div>Unknown</div>
      }

      return <div>{flow.title}</div>
    },
    [flows, tab]
  )

  const viewStage = React.useCallback(() => {
    setTarget(option.then)
  }, [setTarget, option.then])

  return (
    <>
      <div className={clsx(classes.field, classes.input)}>
        <CustomFieldInput
          field={field}
          value={option.when}
          handleChange={val => onChange('when', val, index)}
          handleBlur={() => {}}
          canEdit
          inputOnly
          meta={[]}
        />
      </div>

      <div className={clsx(classes.field, classes.menu)}>
        {/* @ts-ignore */}
        <ButtonMenu
          renderOption={renderOption}
          options={stageOptions}
          onSelect={val => onChange('then', val, index)}
          menuProps={{
            anchorOrigin: {
              horizontal: 'left',
              vertical: 'bottom'
            },
            transformOrigin: {
              horizontal: 'left',
              vertical: 'top'
            }
          }}
        >
          {renderOption(option.then)}
        </ButtonMenu>

        <ExportSquare
          onClick={viewStage}
          size={theme.size.base}
          style={{ cursor: 'pointer' }}
        />
      </div>

      <div className={classes.field}>
        <Spacer />
        {children}
      </div>
    </>
  )
}

export default FlowFieldOption
